module.exports = new __parcel__URL__("json-icon.2bb3a37b.svg").toString();